import { Plugin } from 'prosemirror-state';
import { ContentNodeWithPos } from 'prosemirror-utils';

import { AddMenuQuote, Quote } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock, setPlaceholder } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    new Plugin({
      view: (editorView) => {
        setPlaceholder(editorView, NODE_NAME, (_contentNode: ContentNodeWithPos) =>
          t('Lygo:Quote'),
        );

        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.blockquote.title') as string,
            icon: Quote,
            addMenuIcon: AddMenuQuote,
            addMenuItemType: addMenuItemType.basic_blocks,
            description: t('Lygo:Menu.blockquote.description') as string,
            searchWords: ['text', 'blockquote', 'quote', 'basic'],
            isText: true,
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
